import * as React from 'react';
import { FC, useState, useEffect } from 'react';
import { InView } from 'react-intersection-observer';
import 'intersection-observer';
import picturefill from 'picturefill';

import { translateHtmlEntities } from 'app/helpers/strings';
import Links from './Links';
import Badges from './Badges';
import { CasinoGamesProps, Game } from './types';
import { GameStarter } from './useGameStarter';

const GameComponent: FC<{
  game: Game;
  common: CasinoGamesProps['common'];
  gameStarter: GameStarter;
}> = ({ game, common, gameStarter }) => {
  const [linksClassName, setLinksClassName] = useState('');
  const [visible, setVisible] = useState(false);

  const gameLabelId = `game-label-${game.id}`;

  const onMouseEnter = () => {
    setLinksClassName('flipInX');
  };

  const onMouseLeave = () => {
    setLinksClassName('flipOutX');
  };

  const track = (inView: boolean) => {
    setVisible((prev) => prev || inView);
    return true;
  };

  useEffect(() => {
    if (visible) picturefill();
  }, [visible]);

  const image = () => (
    <div className="img-wrap img-wrap_fixed">
      <img className="rs-game-placeholder" src={common.blankImageUrl} alt="" />
      <picture>
        <source srcSet={game.srcset} />
        <img
          loading="lazy"
          className="not-loaded"
          src={game.srcset.split(' ', 1).toString()}
          alt={translateHtmlEntities(game.gameLocaleName)}
          height={common.imgHeight}
          width={common.imgWidth}
        />
      </picture>
    </div>
  );

  const blankImage = () => (
    <div className="game-placeholder-wrap">
      <img src={common.blankImageUrl} alt="" />
    </div>
  );

  const gameLinks = () => (
    <Links gameStarter={gameStarter} game={game} common={common} linksClassName={linksClassName} />
  );

  const heartIcon = () => (
    <div className={`favorite ${game.favoriteClassName}`}>
      <i className="fa fa-heart-o" />
    </div>
  );

  const gameInView = () => (
    <InView onChange={(inView) => track(inView)}>
      {({ ref }) => (
        <div
          ref={ref}
          className={`game img-zoom-container ${game.gameClassName}`}
          data-game-id={game.id}
          data-demo={game.demo}
        >
          {common.playerPresent ? heartIcon() : null}
          <div className="link">
            {game.imagePresent && visible ? image() : blankImage()}
            <Badges ids={game.casino_badge_ids} badges={common.badges} />
            <span className="name" id={gameLabelId}>
              {translateHtmlEntities(game.gameLocaleName)}
            </span>
            {linksClassName ? gameLinks() : null}
          </div>
        </div>
      )}
    </InView>
  );

  return (
    <div
      className="game_container"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      aria-labelledby={gameLabelId}
    >
      {gameInView()}
    </div>
  );
};

export default GameComponent;
